"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomUser = void 0;
const pixi_js_1 = require("pixi.js");
const tween_js_1 = __importDefault(require("@tweenjs/tween.js"));
const figure_1 = require("../../imager/avatar/util/figure");
const action_1 = require("../../imager/avatar/util/action");
const AnimationManager_1 = require("../../imager/avatar/animation/AnimationManager");
const IsoPoint_1 = require("../../../engine/lib/IsoPoint");
class RoomUser {
    constructor(model, room) {
        this.model = model;
        this.room = room;
        this.animationManager = new AnimationManager_1.AnimationManager();
        this.teleTween = new tween_js_1.default.Tween({ x: 0, y: 0 });
        this.iso = new IsoPoint_1.IsoPoint();
        this.startAnimationLoop = () => {
            const frame = this.animationManager.nextFrame();
            if (!frame)
                return;
            // Update HumanPartOptions
            for (const [setType, partOptions] of Object.entries(frame.bodyparts)) {
                const humanParts = this.structure.groups[setType];
                if (!humanParts)
                    continue;
                humanParts.forEach((humanPart) => {
                    var _a, _b, _c, _d;
                    humanPart.assetpartdefinition = (_a = partOptions.assetpartdefinition) !== null && _a !== void 0 ? _a : humanPart.assetpartdefinition;
                    humanPart.frame = (_b = partOptions.frame) !== null && _b !== void 0 ? _b : humanPart.frame;
                    humanPart.dx = Number((_c = partOptions.dx) !== null && _c !== void 0 ? _c : humanPart.dx);
                    humanPart.dy = Number((_d = partOptions.dy) !== null && _d !== void 0 ? _d : humanPart.dy);
                });
            }
            // Update Offsets
            const offsets = frame.offsets[this.model.direction] || {};
            for (const [activePartset, offset] of Object.entries(offsets)) {
                const setTypes = this.room.avatarImager.partsets.activePartSets[activePartset];
                setTypes.forEach((setType) => {
                    const humanParts = this.structure.groups[setType];
                    if (!Array.isArray(humanParts))
                        return;
                    humanParts.forEach((humanPart) => {
                        humanPart.dx = Number(offset.dx);
                        humanPart.dy = Number(offset.dy);
                    });
                });
            }
            // Update Sprites
            for (const [setType, humanParts] of Object.entries(this.structure.groups)) {
                const partContainer = this.structure.partTypeToContainer[setType];
                if (!Array.isArray(humanParts))
                    continue;
                humanParts.forEach((humanPart, index) => {
                    const sprite = partContainer.children[index];
                    this.structure.updateSprite(sprite, humanPart);
                });
            }
        };
        this.iso.set(model.x, model.y, model.z);
    }
    initSprite() {
        return __awaiter(this, void 0, void 0, function* () {
            const { name, look, action, direction, head_direction, is_ghost, x = 0, y = 0 } = this.model;
            const { container, structure } = yield this.room.avatarImager.createFigure({
                figure: figure_1.HumanFigure.decode(look),
                actions: action_1.HumanActions.decode(action),
                direction,
                head_direction,
                is_ghost,
            });
            container.name = `user: ${name}`;
            this.container = container;
            this.structure = structure;
            this.startAnimations();
            return this.container;
        });
    }
    startAnimations() {
        RoomUser.ticker.add(this.startAnimationLoop);
        const { actionTypeToAnimationName } = this.room.avatarImager;
        this.animationManager.animations = [];
        for (const action of this.structure.actions) {
            const animationName = actionTypeToAnimationName[action.state];
            const animation = this.room.avatarImager.animations[animationName];
            if (!animation) {
                continue;
            }
            this.animationManager.add(animation);
        }
        this.animationManager.buildFrames();
    }
    destroy() {
        RoomUser.ticker.remove(this.startAnimationLoop);
    }
    setPosition(position) {
        this.iso = position;
        position.toPoint().copyTo(this.container.position);
        return this;
    }
    moveTo(position) {
        this.teleTween.stop();
        this.teleTween = new tween_js_1.default.Tween({
            x: this.iso.x,
            y: this.iso.y,
            z: this.iso.z,
        }).to({
            x: position.x,
            y: position.y,
            z: position.z,
        }, 400)
            .onUpdate(({ x, y, z }) => {
            this.setPosition(this.iso.set(x, y, z));
        })
            .start(undefined);
    }
}
exports.RoomUser = RoomUser;
RoomUser.ticker = new pixi_js_1.Ticker();
RoomUser.ticker.maxFPS = 12;
RoomUser.ticker.start();
